/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */

/* NPM Imports Start */
import notify from 'devextreme/ui/notify';
import PropTypes from 'prop-types';
import { n4000 } from './../../../constant';
/* NPM Imports End */

/* Project Imports Start */

/* Project Imports End */

/* CCS & Image imports Start */
import './toasterMessage.scss';
/* CCS & Image imports End */

export const ToasterMessage = (type, text) => notify(text, type, n4000);

export const ToasterMessageWithOptions = (options, type) =>
  notify(options, type, n4000);

ToasterMessage.displayName = 'ToasterMessage';

/* PropsTypes Validation Start*/
ToasterMessage.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string,
};
/* PropsTypes Validation End*/

/* DefaultProps */
ToasterMessage.defaultProps = {
  text: 'Sample Toaster Message',
  type: 'success',
};
/* DefaultProps */
